import loadHeroImage from "shared/lib/load_hero_image"
import truncate from "lodash/truncate"

import "./related_stories.scss"

interface RelatedStoriesProps {
  relatedStories: {
    slug: string
    title: string
    hero_image: { background_color: string }
    description: boolean
  }[]
  storyPath: string
}

const RelatedStories = ({ relatedStories, storyPath }: RelatedStoriesProps) => (
  <>
    <h2>You may also like</h2>
    <section styleName="related-content">
      {relatedStories.map(story => (
        <a key={story.slug} href={`${storyPath}${story.slug}`} rel="noreferrer" styleName="story-card">
          <div
            styleName="hero"
            title={story.title}
            aria-label={story.title}
            style={{
              backgroundColor: `${story.hero_image["background_color"]}`,
            }}
          >
            <img
              src={loadHeroImage(story.hero_image, "square")}
              title={story.title}
              alt={story.title}
              loading="lazy"
              width="336"
              height="200"
            />
          </div>
          <div styleName="title">
            <h5>{story.title}</h5>
          </div>

          <p styleName="description">
            {truncate(story.description, {
              length: 240,
              separator: /[ ,]/,
            })}
          </p>
        </a>
      ))}
    </section>
  </>
)

export default RelatedStories
